<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Equipment Information in Orders</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            <button *ngIf="!InProccessing" type="button" style="margin-right: 5px;"
              (click)="openModal_DeviceBehfa(templateDeviceBehfa)" class="btn btn-danger left"> Behfa Equipment <i
                class="fa fa-building"></i> </button>
          </label>
          <input [(ngModel)]="Selected_DataList_DeviceBehfa.codeBEHFA" name="codeBEHFA" type="text" class="form-control"
            disabled>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date (Order)</label>
          <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date (Order)</label>
          <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Group</label>
          <select  (change)="Read_Second_Device_Group()"  name="First_Device_Group_Selected" [(ngModel)]="First_Device_Group_Selected" class="custom-select">
            <option value="0">All</option>
            <option  *ngFor="let item of DataList_First_Device_Group" [value]="item.id" >{{item.title}}</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Subgroup</label>
          <select  [(ngModel)]="Second_Device_Group_Selected"  name="Second_Device_Group_Selected" class="custom-select">
            <option value="0">All</option>
            <option  *ngFor="let item of DataList_Second_Device_Group" [value]="item.id" >{{item.title}}</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Device(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Letter Number</th>
              <th>Decree Number</th>
              
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>



            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of DataList_DeviceBehfa_Schedule
                            | paginate
                                    : {
                                        id: 'DataList_DeviceTable',
                                        itemsPerPage: 50,
                                        currentPage: page,
                                        totalItems: (DataList_DeviceBehfa_Schedule).length
                                      }">


              <tr>
                <td rowspan="5">{{DataList_DeviceBehfa_Schedule.indexOf(item)+1}}</td>
                
                <td>{{item.code}}</td>
                <td>{{item.code2}}</td>
                <td class="EnglishClm">{{item.description}}</td>
                <td class="EnglishClm">{{item.manufacturer}}</td>
                <td class="EnglishClm">{{item.model}}</td>
                <td class="EnglishClm">{{item.codeBEHFA}}</td>

              </tr>

              <tr>
                <th>Customer Name</th>
                <td colspan="3">{{item.customer}}</td>
                <th>Date Order</th>
                <td>{{item.scheduleDate}}</td>

              </tr>

              <tr>

                <th>Status Order</th>
                <td>{{item.scheduleState}}</td>
                <th>Created Date</th>
                <td>{{item.createrDate}}</td>
                <th>Created By</th>
                <td>{{item.creater}}</td>
              </tr>

              <tr>
                <th>Modified Date</th>
                <td>{{item.editorDate}}</td>
                <th>Modified By</th>
                <td>{{item.editor}}</td>
                <th>Status Equipment</th>
                <td>{{item.deviceState}}</td>
              </tr>

              <tr>
                <th>Change Description</th>
                <td colspan="5">{{item.editorDsc}}</td>
              </tr>



            </ng-container>

          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_DeviceTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<ng-template #templateDeviceBehfa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Behfa Equipment List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBehfa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <app-DeviceBehfaActiveList [inner_PersianDate]=""
      (seleted_DeviceBehfa_Interface)="Set_Selected_DeviceBehfa_Record($event)">

    </app-DeviceBehfaActiveList>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBehfa.hide()">Close</button>
  </div>
</ng-template>



<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>Letter Number</th>
      <th>Decree Number</th>
      <th>Customer Name</th>
      <th>Date Order</th>
      <th>Status Order</th>
      <th>Created Date</th>
      <th>Created By</th>
      <th>Modified Date</th>
      <th>Modified By</th>
      <th>Status Equipment</th>
      <th>Change Description</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_DeviceBehfa_Schedule
    | paginate
            : {
                id: 'DataList_DeviceTable',
                itemsPerPage: 50,
                currentPage: page,
                totalItems: (DataList_DeviceBehfa_Schedule).length
              }">
      <td>{{DataList_DeviceBehfa_Schedule.indexOf(item)+1}}</td>
      <td>{{item.code}}</td>
      <td>{{item.code2}}</td>
      <td>{{item.customer}}</td>
      <td>{{item.scheduleDate}}</td>
      <td>{{item.scheduleState}}</td>
      <td>{{item.createrDate}}</td>
      <td>{{item.creater}}</td>
      <td>{{item.editorDate}}</td>
      <td>{{item.editor}}</td>
      <td>{{item.deviceState}}</td>
      <td>{{item.editorDsc}}</td>
    </tr>

  </tbody>
</table>